import React, {useState, useEffect} from 'react';
import { makeStyles, Divider, Typography, Button, TextField, InputLabel, Input, FormHelperText, FormControlLabel, Checkbox, FormControl } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import clsx from 'clsx';
import CloseIcon from '@material-ui/icons/Close';
import {apiDataService} from '../../Services/apiDataService';
import { toast } from 'react-toastify';
export default function AddEditDrawer(props) {
    const classes = useStyles();
    const [addeditObject, setAddeditObject] = useState({});

    useEffect(() => {
        if(props.editId !== null){
            let editObject = props.rows.find(r => r.id === props.editId);
            if(JSON.stringify(editObject) !== JSON.stringify(addeditObject)) {
                setAddeditObject(editObject);
            }
        } else {
            //let newObj = {id: 0, enabled: "true", allowAccessTokensViaBrowser: false, alwaysIncludeUserClaimsInIdToken: false, requireClientSecret: false, clientId: "", clientName: "", clientUri: "", absoluteRefreshTokenLifetime: 2592000, accessTokenLifetime: 3600, authorizationCodeLifetime: 300, deviceCodeLifetime: 300, identityTokenLifetime: 300, slidingRefreshTokenLifetime: 1296000, properties: properties}
            let newObj = {id: 0, enabled: true}
            if (JSON.stringify(addeditObject) !== JSON.stringify(newObj) ){
                setAddeditObject(newObj);
            }
        }
    }, [props.editId, props.rows, addeditObject]);

    const fieldChanged = (column, value) => {
        let obj = addeditObject;
        obj[column] = value;
        setAddeditObject(obj);
    }

    const handleAddEdit = (row, title) => {
        if(title === "Edit") {
            apiDataService.editRow(row).then(() => props.setReload(true)).catch((error) => {
                toast.error(error, {
                  position: toast.POSITION.TOP_CENTER
                });
              });
        }

        if(title === "Add") {
            console.log('Add');
            apiDataService.addRow(row).then(() => props.setReload(true)).catch((error) => {
                toast.error(error, {
                  position: toast.POSITION.TOP_CENTER
                });
              });
        }

        props.openDrawer("", false, null)
    };

    const GetEditorForColumn = (column) => {
        //console.log(column)
        if(column.type === "hidden"){
            return <Typography value={addeditObject[column.name]} className={classes.field} />
        } else if (column.type === "text"){
            if (column.helper === true){
                return <FormControl className={classes.field}>
                    <InputLabel htmlFor="my-input">{column.title}</InputLabel>
                    <Input fullWidth type="text" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())}  key={column.name} label={column.name} />
                    <FormHelperText id="my-helper-text">{column.helperText}</FormHelperText>
                </FormControl>
            }else{
                return <TextField fullWidth type="text" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.title} />

            }
        }else if (column.type === "textlist"){
            if (column.helper === true){
                return <FormControl className={classes.field}>
                    <InputLabel htmlFor="my-input">{column.title} (; seperated)</InputLabel>
                    <Input fullWidth type="text" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())}  key={column.name} label={column.name} />
                    <FormHelperText id="my-helper-text">{column.helperText}</FormHelperText>
                </FormControl>
            }else{
                return <TextField fullWidth type="text" defaultValue={addeditObject[column.title]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name + " (; seperated)"} />

            }
        }else if (column.type === "int"){
            if (column.helper === true){
                return <FormControl className={classes.field}>
                    <InputLabel htmlFor="my-input">{column.title} (; seperated)</InputLabel>
                    <Input fullWidth type="number" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())}  key={column.name} label={column.name} />
                    <FormHelperText id="my-helper-text">{column.helperText}</FormHelperText>
                </FormControl>
            }else{
                return <TextField fullWidth type="number" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name + " (; seperated)"} />

            }
        }else if (column.type === "bool"){
                return <FormControlLabel
                key={column.name}
                className={classes.field}
                fullWidth
                value="end"
                control={<Checkbox color="primary" defaultChecked={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.checked)} key={column.name} label={column.name}  />}
                label={column.name}
                labelPlacement="end"
            />
        }else if (column.type === "list"){
            return <Typography value={addeditObject[column.name]} className={classes.field} />
        }
    }

    const GetEditorForprop = (column, index) => {
       // return <TextField fullWidth type="text" defaultValue={column.value} onChange={(e) => propChanged(index, e.target.value.toString())} className={classes.field} key={column.name} label={GetPropName(column.key)} />
    }

  
    const mapProperties = () => {
        if(addeditObject.properties) {
            return addeditObject.properties.map((prop, index) => (
                GetEditorForprop(prop, index)                        
            ))
        }
    }

    return <Drawer variant="temporary" className={clsx(classes.drawer, {[classes.drawerOpen]: props.drawerOpen,[classes.drawerClose]: !props.drawerOpen,})} classes={{paper: clsx({[classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen,}),}} anchor='right' open={props.drawerOpen} onClose={() => props.openDrawer("", false, null)}>
                <div className={classes.headerRow}>
                    <Typography className={classes.headerTitle}>{props.title}</Typography>
                    <Button className={classes.closeButton} onClick={() => props.openDrawer("", false, null)}><CloseIcon></CloseIcon></Button>

                </div>
               
                <Divider />
                <div className={classes.drawerBody}>
                    {props.columns.map((column, index) => (
                        GetEditorForColumn(column)                        
                    ))}
                    {mapProperties()}

                 
          

                </div>
                <div className={classes.buttonContainer}>
                        <Button className={classes.saveButton} onClick={() => handleAddEdit(addeditObject, props.title)}  variant="contained">Save</Button>
                    </div>
            </Drawer>
}

const useStyles = makeStyles((theme) => ({
    headerRow: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    spacer80: {
        height: '80px'  
    },
  
    paper: {
          padding: '50px',
          margin: "50px",
          height: '70%'
    },

    crudDrawer: {
        width: 250,
    },

    drawer: {
        width: '50%',
        flexShrink: 0,
        whiteSpace: 'nowrap',
        padding: '20px'
    },

    drawerOpen: {
        width: '50%' ,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        paddingLeft: '20px'
    },

    drawerClose: {
        width: 0,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden'
    },

    field: {
        marginTop: "10px",
        display: "block !important"
    },
    buttonContainer: {
        height: '10%',

        display: 'flex ',
        alignItems: 'center',
        justifyContent: 'center'
    },
    saveButton: {
        width: '25%',
        marginLeft: '10px',
        backgroundColor: "#5CC958",
        color:"white"
    },

    sectretsButton: {
        width: '25%',
        marginLeft: '10px',
        marginTop: "20px",
        marginBottom: "20px"
    },

    drawerBody: {
        width: '100%',
        height: "90%",
        overflowY: "auto",
        display: "block !important"
    },

    headerTitle: {
        fontSize: '22pt'
    },
}));